<template>
  <div class="d-flex flex-center h-100">
    <spinner/>
  </div>
</template>

<script>
import authWithToken from '@/mixins/auth-token';

export default {
  name: 'auth-with-token',
  mixins: [authWithToken],
  props: {
    token: {
      type: String,
      required: true,
    },
    redirect: {
      type: String,
      required: false,
      default: '/',
    },
  },
  async mounted () {
    try {
      await this.authenticateWithToken(this.token);
      window.location.href = this.redirect;
    } catch (err) {
      this.$router.push({ name: 'homepage' });
    }
  },
};
</script>
